import { useTranslation } from "@/packages/utils";
import { AlertTriangle } from "lucide-react";
import { CustomerPortalLink } from "@convex-dev/polar/react";
import { api } from "convex/_generated/api";
import { Button } from "@/components/ui";

export function PastDueBanner() {
  const { t } = useTranslation(["settings"]);

  return (
    <div className="mb-6 rounded-card border border-red-300 bg-red-50 dark:bg-red-950/20 dark:border-red-800 p-4">
      <div className="flex items-start gap-3">
        <AlertTriangle
          size={20}
          className="text-red-600 dark:text-red-400 mt-0.5 shrink-0"
        />
        <div className="flex-1">
          <p className="text-[14px] font-medium text-red-800 dark:text-red-300">
            {t("settings:billing.pastDueTitle")}
          </p>
          <p className="text-[12px] text-red-700 dark:text-red-400 mt-1">
            {t("settings:billing.pastDueDescription")}
          </p>
        </div>
        <CustomerPortalLink
          polarApi={{
            generateCustomerPortalUrl: api.polar.generateCustomerPortalUrl,
          }}
        >
          <Button variant="primary" size="sm">
            {t("settings:billing.updatePaymentMethod")}
          </Button>
        </CustomerPortalLink>
      </div>
    </div>
  );
}
